import React from "react";

import { LoanRepaymentDetail } from "../../../containers";

const LoanRepaymentDetailReport = (props) => {
  return <LoanRepaymentDetail {...props} />;
};

export default LoanRepaymentDetailReport;
